import { useLazyQuery } from '@collinsonx/utils/apollo';
import { Booking } from '@collinsonx/utils/generatedTypes/graphql';
import { getBookingByID } from '@collinsonx/utils/queries';
import { BookingContext } from 'context/BookingContext';
import { useContext, useEffect } from 'react';

type UseBookingDetailsProps = {
  onCompleted?: (data: FetchBookingDetailsData) => void;
};

export type FetchBookingDetailsData = {
  getBookingByID: Booking;
};

interface UseBookingDetails {
  bookingDetailsData?: FetchBookingDetailsData;
  loadingBookingDetails: boolean;
}

const useBookingDetails = ({
  onCompleted,
}: UseBookingDetailsProps = {}): UseBookingDetails => {
  const { booking } = useContext(BookingContext);

  const urlParams = new URLSearchParams(window.location.search);
  const idParam = urlParams.get('bookingId');

  const { bookingId } = booking;

  const [
    fetchBookingDetails,
    { data: bookingDetailsData, loading: loadingBookingDetails },
  ] = useLazyQuery<{
    getBookingByID: Booking;
  }>(getBookingByID, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted,
    variables: {
      getBookingById: bookingId || idParam,
    },
  });

  useEffect(() => {
    if (!bookingId && !idParam) return;

    fetchBookingDetails();
  }, [bookingId, idParam]);

  return {
    bookingDetailsData,
    loadingBookingDetails,
  };
};

export default useBookingDetails;
